import { getApiErrorMessage } from "./error";
import {
  mapProfileSkillWriteError,
  type ProfileSkillWriteErrorKind,
} from "./profile-skill-write-error";

export type LinkedInProfileErrorKind =
  | Exclude<ProfileSkillWriteErrorKind, { kind: "generic" }>
  | { kind: "invalid_request" }
  | { kind: "not_found" }
  | { kind: "server_error" }
  | { kind: "generic"; message: string };

export const mapLinkedInProfileError = (
  error: unknown,
  options: { skillWrite?: boolean } = { skillWrite: true },
): LinkedInProfileErrorKind => {
  if (options.skillWrite !== false) {
    const skillWriteError = mapProfileSkillWriteError(error);
    /* Un 400 senza testo non parla di competenze: qui la copy di LinkedIn
       («verifica l'URL») è più vera di «controlla le competenze». */
    const isSilentValidation =
      skillWriteError.kind === "validation" && !skillWriteError.message;
    if (skillWriteError.kind !== "generic" && !isSilentValidation) {
      return skillWriteError;
    }
  }

  const response =
    typeof error === "object" && error !== null && "response" in error
      ? (error as { response?: { status?: number } }).response
      : undefined;
  const status = response?.status;

  if (status === 400) return { kind: "invalid_request" };
  if (status === 404) return { kind: "not_found" };
  /* Ogni 5xx, non solo il 500: nei 5xx il BE di LinkedIn scrive solo testo
     tecnico inglese («Failed to fetch LinkedIn profile: …»), e un 502 o un
     504 arriva dal gateway, non da noi. */
  if (status !== undefined && status >= 500) return { kind: "server_error" };
  /* Si passa la sola `response` e non l'errore: senza la risposta
     `getApiErrorMessage` ripiega su `error.message` («Network Error»,
     «Request failed with status code 403»), e il chiamante ha già la sua
     copy italiana per quando il BE non dice niente. */
  return {
    kind: "generic",
    message: response ? getApiErrorMessage({ response }, "") : "",
  };
};
